import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Auth } from 'src/app/models/auth.model';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { TempUser } from 'src/app/models/tempuser.model';
import { RefreshStateService } from 'src/app/services/refresh-state/refresh-state.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl: string = environment.apiUrl


  private currentUserSource = new BehaviorSubject<Auth | null>(null)
  currentUser$ = this.currentUserSource.asObservable();

  // Auth token is held in memory (not Web Storage) to avoid XSS-based token theft (OWASP A07).
  private token: string | null = null;

  constructor(
    private http: HttpClient,
    private refreshState: RefreshStateService,
  ) {
  }

  setToken(token: string | null): void {
    this.token = token ?? null;
  }

  clearToken(): void {
    this.token = null;
  }

  login(model: any) {
    return this.http.post<Auth>(this.baseUrl + '/auth/login', model).pipe(
      map((response: Auth) => {
        const user = response;
        if (user) {
          this.setToken(user?.message?.jwtToken);
          localStorage.setItem('role', user.message.role)
          localStorage.setItem('firstName', user.message.firstName)
          localStorage.setItem('lastName', user.message.lastName)
          localStorage.setItem('email', model.username)
          localStorage.setItem('assignedPlants', JSON.stringify(user.message.assignedPlants))
          this.currentUserSource.next(user)
        }
      })
    )
  }

  getUserDetails() {
    return this.http.get<any>(this.baseUrl + '/auth/user-details', {}).pipe(
      map((response: any) => {
        const user = response;
        return user;
      })
    )
  }

  deactivateUser(email: string) {
    return this.http.patch<any>(this.baseUrl + '/auth/deactivate-user', { email }).pipe(
      map((response: any) => {
        const user = response;
        return user;
      })
    )
  }

  deactivateTempUser(email: string) {
    return this.http.patch<any>(this.baseUrl + '/auth/deactivate-temp-user', { email }).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  updateUserDetails(model: any) {
    return this.http.patch<any>(this.baseUrl + '/auth/update-details', model).pipe(
      map((response: any) => {
        const user = response;
        return user;
      })
    )
  }

  getToken() {
    return this.token;
  }


  handleForgetPassword(model: any) {
    return this.http.post<Auth>(this.baseUrl + '/user/requestPasswordReset', model).pipe()
  }

  handleResetSubmit(model: any) {
    return this.http.post<Auth>(this.baseUrl + '/user/resetPassword', model).pipe(
      map((response: Auth) => {
        const user = response;
        // disable auto login of user on password update
        if (user) {
          localStorage.setItem('role', user.message.role)
          // this.currentUserSource.next(user)
        }
      })
    )
  }

  handleVerifyEmail(model: any) {
    return this.http.post<Auth>(this.baseUrl + '/auth/update-password', model).pipe(
      map((response: Auth) => {
        const user = response;
        if (user) {
          localStorage.setItem('role', user.role[0])
        }
      })
    )
  }

  setCurrentUser(user: Auth) {
    this.currentUserSource.next(user)
  }

  logout() {
    this.refreshState.clearCurrentUser();
    this.clearToken();
    this.currentUserSource.next(null);
  }

  register(model: any) {
    return this.http.post<Auth>(this.baseUrl + '/auth/register', model)
  }

  createKeycloakUser(model: any) {
    return this.http.post<Auth>(this.baseUrl + '/auth/register', model)
  }

  registerTempUser(model: any) {
    return this.http.post<Auth>(this.baseUrl + '/tempUser/register', model)
  }

  registerBulk(model: any) {
    return this.http.post<any>(this.baseUrl + '/auth/register/bulk', model)
  }

  createKeycloakUsersBulk(model: any) {
    return this.http.post<any>(this.baseUrl + '/auth/register/bulk', model)
  }

  updateUser(id: number, payload: any) {
    return this.http.patch<Auth>(this.baseUrl + `/auth/edit-non-admin-user/${id}`, payload)
  }

  updateKeycloakManagedUser(id: number, payload: any) {
    return this.http.patch<Auth>(this.baseUrl + `/auth/edit-non-admin-user/${id}`, payload)
  }

  updateKeycloakManagedUserBySubject(subjectId: string, payload: any) {
    return this.http.patch<Auth>(this.baseUrl + `/auth/edit-non-admin-user-by-subject/${encodeURIComponent(subjectId)}`, payload)
  }

  updateTempUser(id: number, payload: any): Observable<TempUser> {
    return this.http.patch<TempUser>(this.baseUrl + `/auth/edit-temp-user/${id}`, payload);
  }


  // /api/Auth/edit-non-admin-user/{id}

  // register(model: any){
  //   return this.http.post<Auth>(this.baseUrl + '/auth/register', model).pipe(
  //     map((response: Auth) => {
  //       const user = response;
  //       if (user) {
  //         localStorage.setItem('user', JSON.stringify(user))
  //         this.currentUserSource.next(user)
  //       }
  //     })
  //   )
  // }
}
